import { render, staticRenderFns } from "./AddGlSubHeader.vue?vue&type=template&id=601d65c0"
import script from "./AddGlSubHeader.vue?vue&type=script&lang=js"
export * from "./AddGlSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports